import { requireApiClient } from '../api-client.helper';
import type { UserProfile } from '@yoop/whitelabel-data';
import { dateOfBirthFrom } from '@yoop/whitelabel-data';
import type { UserProfileResponse } from '@yoop/server-model/user-account';
import { UserAuthenticationState } from '@yoop/server-model/user-account';

export const getUserProfile = async (): Promise<UserProfile> => {
  const profile = await requireApiClient().userController.getUserProfile();
  return userProfileFrom(profile);
};

export const logoutUser = async (): Promise<void> => {
  await requireApiClient().userController.logout();
};

const userProfileFrom = (response: UserProfileResponse): UserProfile => {
  return {
    globalUserId: response.globalUserId,
    dateOfBirth: dateOfBirthFrom(response.dateOfBirth),
    emailAddress: response.emailAddress,
    firstName: response.firstName,
    lastName: response.lastName,
    pictureUrl: response.profilePictureUrl,
    isEmailVerified: response.userAuthenticationState === UserAuthenticationState.EMAIL_VERIFIED,
    isPictureVerified: response.profilePictureVerificationStatus,
    postalCode: response.postalCode,
    countryCode: response.countryCode,
  };
};
